import React from "react";
import { CheckBox, TagBox, TextBox } from "devextreme-react";

const factors = [
  { id: 1, value: "EMAIL", display: "Email" },
  { id: 2, value: "GOOGLE_APP", display: "Google Authenticator App" },
  { id: 2, value: "MS_APP", display: "Microsoft Authenticator App" },
];

const MultiFactorSecurity = ({ value, onValueChange }) => {
  const {
    two_factor_enabled,
    two_factor_channels,
    two_factor_keys_as_words,
    two_factor_mandatory,
    admin_2fa_notification_emails,
    two_factor_disable_user_email_edit,
  } = value;

  return (
    <div className='mb-5'>
      <table className='table table-bordered align-middle mt-1'>
        <thead className='table-dark'>
          <tr>
            <th scope='col'>Setting</th>
            <th scope='col'>Value</th>
            <th scope='col'>Explanation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope='row'>Allow Multi-Factor Authentication</th>
            <td className='text-center'>
              <CheckBox
                value={two_factor_enabled}
                onValueChanged={(e) => onValueChange(e, "two_factor_enabled")}
              />
            </td>
            <td>Allow users to enroll into multi-factor authentication.</td>
          </tr>
          <tr>
            <th scope='row'>Multi-Factor Authentication Is Mandatory</th>
            <td className='text-center'>
              <CheckBox
                value={two_factor_mandatory}
                onValueChanged={(e) => onValueChange(e, "two_factor_mandatory")}
                disabled={!two_factor_enabled}
              />
            </td>
            <td style={{ width: "30%" }}>
              Multi-factor authentication is mandatory for all users who log in
              via{" "}
              <a
                href='https://login.erply.com'
                target='_blank'
                rel='noreferrer'
              >
                login.erply.com
              </a>
              . Users who have not enrolled yet, will be guided through the
              procedure on their next login.{" "}
            </td>
          </tr>
          <tr>
            <th scope='row'>Second Factors Allowed</th>
            <td style={{ width: "40%" }}>
              <TagBox
                dataSource={factors}
                displayExpr='display'
                valueExpr='value'
                searchEnabled={true}
                value={two_factor_channels}
                onValueChanged={(e) => onValueChange(e, "two_factor_channels")}
                valueChangeEvent='keyup'
                showClearButton={true}
                showSelectionControls={true}
                selectAllMode='allPages'
              />
            </td>
            <td>
              Select which channels users are allowed to use for multi-factor
              authentication.
            </td>
          </tr>

          <tr>
            <th scope='row'>Use Phrases In Email Challenge</th>
            <td className='text-center'>
              {" "}
              <CheckBox
                value={two_factor_keys_as_words}
                onValueChanged={(e) =>
                  onValueChange(e, "two_factor_keys_as_words")
                }
              />
            </td>
            <td>
              By default, the confirmation email contains an alphanumeric code,
              such as “a1C8rfSO”. Turn on this setting to use word-like phrases
              instead, such as “Nantilien”.
            </td>
          </tr>
          <tr>
            <th scope='row'>
              Only Administrators Can Configure Two-Factor Authentication Emails
            </th>
            <td className='text-center'>
              {" "}
              <CheckBox
                value={two_factor_disable_user_email_edit}
                onValueChanged={(e) =>
                  onValueChange(e, "two_factor_disable_user_email_edit")
                }
              />
            </td>
            <td>
              Enforce a process where users themselves are not allowed to set
              up, change, or remove two-factor authentication emails. <br />
              Administrators can configure users' emails in Settings {">"} Users
              (new). <br />
              This restriction does not prevent users from setting up
              authenticator apps.
            </td>
          </tr>
          <tr>
            <th scope='row'>
              Email Addresses for Two-Factor Authentication Notifications
            </th>
            <td className='text-center'>
              {" "}
              <TextBox
                value={admin_2fa_notification_emails}
                onValueChanged={(e) =>
                  onValueChange(e, "admin_2fa_notification_emails")
                }
              />
              <small style={{ marginTop: "5px" }}>
                Use commas to separate email addresses
              </small>
            </td>
            <td>
              A notification will be sent to these email addresses whenever a
              user sets up or removes an authentication channel (an email or an
              authenticator app). <br />
              You can configure multiple addresses, comma-separated. <br />
              Leave the field empty to disable notifications.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MultiFactorSecurity;
